import { defineMessage } from 'react-intl';

export const buttonCommonI18n = {
  actions: defineMessage({
    id: 'common:button.actions',
    defaultMessage: 'Actions'
  }),
  addPhotos: defineMessage({
    id: 'common:button.add-photos',
    defaultMessage: 'Add photos'
  }),
  back: defineMessage({
    id: 'common:button.back',
    defaultMessage: 'Back'
  }),
  cancel: defineMessage({
    id: 'common:button.cancel',
    defaultMessage: 'Cancel'
  }),
  cancelInvite: defineMessage({
    id: 'common:button.cancel-invite',
    defaultMessage: 'Cancel invitation'
  }),
  choose: defineMessage({
    id: 'common:button.choose',
    defaultMessage: 'Choose'
  }),
  clearDates: defineMessage({
    id: 'common:button.clear-dates',
    defaultMessage: 'Clear dates'
  }),
  clearSelection: defineMessage({
    id: 'common:button.clear-selection',
    defaultMessage: 'Clear selection'
  }),
  close: defineMessage({
    id: 'common:button.close',
    defaultMessage: 'Close'
  }),
  comment: defineMessage({
    id: 'common:button.comment',
    defaultMessage: 'Comment'
  }),
  confirm: defineMessage({
    id: 'common:button.confirm',
    defaultMessage: 'Confirm'
  }),
  confirmPassword: defineMessage({
    id: 'common:button.confirm-password',
    defaultMessage: 'Confirm password'
  }),
  connectAccount: defineMessage({
    id: 'common:button.connect-account',
    defaultMessage: 'Connect'
  }),
  continue: defineMessage({
    id: 'common:button.continue',
    defaultMessage: 'Continue'
  }),
  delete: defineMessage({
    id: 'common:button.delete',
    defaultMessage: 'Delete'
  }),
  disconnectAccount: defineMessage({
    id: 'common:button.disconnect-account',
    defaultMessage: 'Disconnect'
  }),
  dismiss: defineMessage({
    id: 'common:button.dismiss',
    defaultMessage: 'Dismiss'
  }),
  doNotDelete: defineMessage({
    id: 'common:button.do-not-delete',
    defaultMessage: 'Do not delete'
  }),
  doNotSend: defineMessage({
    id: 'common:button.do-not-send',
    defaultMessage: 'Do not send'
  }),
  edit: defineMessage({
    id: 'common:button.edit',
    defaultMessage: 'Edit'
  }),
  filters: defineMessage({
    id: 'common:button.filters',
    defaultMessage: 'Filters'
  }),
  follow: defineMessage({
    id: 'common:button.follow',
    defaultMessage: 'Follow'
  }),
  following: defineMessage({
    id: 'common:button.following',
    defaultMessage: 'Following'
  }),
  like: defineMessage({
    id: 'common:button.like',
    defaultMessage: 'Like'
  }),
  login: defineMessage({
    id: 'common:button.log-in',
    defaultMessage: 'Log in'
  }),
  next: defineMessage({
    id: 'common:button.next',
    defaultMessage: 'Next'
  }),
  previous: defineMessage({
    id: 'common:button.previous',
    defaultMessage: 'Previous'
  }),
  readMore: defineMessage({
    id: 'common:button.read-more',
    defaultMessage: 'Read more'
  }),
  remove: defineMessage({
    id: 'common:button.remove',
    defaultMessage: 'Remove'
  }),
  reply: defineMessage({
    id: 'common:button.reply',
    defaultMessage: 'Reply'
  }),
  resendInvite: defineMessage({
    id: 'common:button.resend-invitation',
    defaultMessage: 'Resend invitation'
  }),
  save: defineMessage({
    id: 'common:button.save',
    defaultMessage: 'Save'
  }),
  saved: defineMessage({
    id: 'common:button.saved',
    defaultMessage: 'Saved'
  }),
  search: defineMessage({
    id: 'common:button.search',
    defaultMessage: 'Search'
  }),
  sendInvite: defineMessage({
    id: 'common:button.send-invitation',
    defaultMessage: 'Send invitation'
  }),
  showMore: defineMessage({
    id: 'common:button.show-more',
    defaultMessage: 'Show more'
  }),
  signUp: defineMessage({
    id: 'common:button.sign-up',
    defaultMessage: 'Sign up'
  }),
  unfollow: defineMessage({
    id: 'common:button.unfollow',
    defaultMessage: 'Unfollow'
  }),
  update: defineMessage({
    id: 'common:button.update',
    defaultMessage: 'Update'
  }),
  updatePassword: defineMessage({
    id: 'common:button.update-password',
    defaultMessage: 'Update password'
  }),
  upload: defineMessage({
    id: 'common:button.upload',
    defaultMessage: 'Upload'
  }),
  uploadFile: defineMessage({
    id: 'common:button.upload-file',
    defaultMessage: 'Upload file'
  }),
  uploadPhoto: defineMessage({
    id: 'common:button.upload-photo',
    defaultMessage: 'Upload photo'
  })
};
